import {productoService} from "../producto.service";
import alertService from "./alert.service";
import http from "./http.service";

class ProductoServiceTs {

    products: any = {};

    otrosProductosVendedor: any = {};

    productosSimilares: any = {};

    relProdIdVendedor: any = {};

    constructor() {
    }

    buscarProductoPorId = (prodId: number, onSuccess: any) => {
        if (!!this.products[prodId]) {
            onSuccess(this.products[prodId].repuestos);
        } else {
            http.get('/public/producto/buscarProductoPorId')
                .then(
                    (data: any) => {
                        this.products[prodId] = data.producto;
                        onSuccess(this.products[prodId]);
                    },
                    (error: any) => alertService.error(error)
                );
        }
    }

    /**
     * Las publicaciones con oferta de la vidriera de la home.
     *
     * <p>No se cachea como los otros sliders: la gracia es que el sorteo cambie entre visitas, y
     * guardarlas dejaria siempre las mismas hasta recargar la pestaña. `onSuccess([])` en el error
     * para que la home no muestre un cartel rojo por un carrusel decorativo — si falla,
     * simplemente no hay vidriera.
     */
    traerProductosEnOferta = (onSuccess: any) => {
        http.post('/public/producto/buscarProductosEnOferta', {})
            .then(
                (data: any) => onSuccess(data?.productos ?? []),
                () => onSuccess([])
            );
    }

    crearNombreMotorAsociados = (producto: any) => {
        let nombre = '';

        producto.motorAsociados?.forEach((asoc: any) => {
            nombre = nombre + asoc.nombre + ', '
        });

        if (nombre != '')
            nombre = nombre.substring(0, nombre.length - 2)


        return nombre;
    }

    traerUltimosProductosPorVendedorByProductId = (prodId: number, onSuccess: any) => {
        if (!!this.relProdIdVendedor[prodId]) {
            onSuccess(this.otrosProductosVendedor[this.relProdIdVendedor[prodId]]);
        } else {
            http.post('/public/producto/buscarOtrosProductosVendedorByProductId', {id: prodId})
                .then(
                    (data: any) => {
                        this.relProdIdVendedor[prodId] = data.vendedorId;
                        this.otrosProductosVendedor[data.vendedorId] = data.productos;
                        onSuccess(this.otrosProductosVendedor[data.vendedorId]);
                    },
                    (error: any) => alertService.error(error)
                );
        }
    }

    traerUltimosProductosPorVendedorByVendedorId = (vendedorId: number, onSuccess: any) => {
        if (!!this.otrosProductosVendedor[vendedorId]) {
            onSuccess(this.otrosProductosVendedor[vendedorId]);
        } else {
            http.post('/public/producto/buscarOtrosProductosVendedorByVendedorId', {id: vendedorId})
                .then(
                    (data: any) => {
                        this.otrosProductosVendedor[vendedorId] = data.productos;
                        onSuccess(this.otrosProductosVendedor[vendedorId]);
                    },
                    (error: any) => alertService.error(error)
                );
        }
    }

    traerProductosSimilares = (prodId: number, onSuccess: any) => {
        if (!!this.relProdIdVendedor[prodId]) {
            onSuccess(this.productosSimilares[this.relProdIdVendedor[prodId]]);
        } else {
            http.post('/public/producto/buscarProductosSimilares', {id: prodId})
                .then(
                    (data: any) => {
                        this.relProdIdVendedor[prodId] = data.vendedorId;
                        this.productosSimilares[data.vendedorId] = data.productos;
                        onSuccess(this.productosSimilares[data.vendedorId]);
                    },
                    (error: any) => alertService.error(error)
                );
        }
    }


    traerDatosRepuestosBaja = (prodId: number, onSuccess: any) => {
        if (!!this.products[prodId]) {
            onSuccess(this.products[prodId].repuestos);
        } else {
            productoService.buscarRepuestosBaja({id: prodId})
                .then((data: any) => {
                    this.products[prodId] = {};
                    this.products[prodId].repuestos = data.repuestos ?? [];
                    onSuccess(this.products[prodId].repuestos);
                })
                .catch((error: any) => {
                    alertService.error(error);
                })
        }
    }

    buscarTotalPublicaciones = (onSuccess: any) => {

        http.get('/api/vendedor/producto/buscarTotalPublicaciones')
            .then(
                (data: any) => {
                    onSuccess(data);
                },
                (error: any) => alertService.error(error)
            );

    }

    /** Totales del back office; sin vendedorId son los de todo el sitio. */
    buscarTotalPublicacionesAdmin = (vendedorId: any, onSuccess: any) => {

        const query = vendedorId ? `?vendedorId=${vendedorId}` : '';

        http.get('/api/admin/producto/buscarTotalPublicaciones' + query)
            .then(
                (data: any) => {
                    onSuccess(data);
                },
                (error: any) => alertService.error(error)
            );

    }

    crearParamBusqueda = (producto: any) => {
        const params = new URLSearchParams();
         // Agregar 'id' si está disponible (asumiendo que es el campo principal)
        if (producto.id) {
            params.append('id', producto.id.toString());
        }

        // Agregar marca si existe y tiene nombre
        if (producto.marca?.nombre) {
            params.append('marca', producto.marca.nombre);
        }

        // Agregar modelo si existe y tiene nombre
        if (producto.modelo?.nombre) {
            params.append('modelo', producto.modelo.nombre);
        }

        // Agregar versión si existe y tiene nombre
        if (producto.version?.nombre) {
            params.append('version', producto.version.nombre);
        }

         // Agregar versión si existe y tiene nombre
        if (producto.tipoRepuesto?.nombre) {
            params.append('tipoRepuesto', producto.tipoRepuesto.nombre);
        }
        return params.toString();

    }

    /**
     * URL canonica y legible de una publicacion: `/producto/123-turbo-ford-ranger`.
     *
     * El id va adelante y es lo unico que se lee para resolver la publicacion, asi
     * que el texto puede cambiar (se edita el aviso) sin romper links compartidos.
     * Es la misma forma que arma el prerender del backend para el og:url/canonical.
     */
    crearUrlProducto = (producto: any) => {
        if (!producto?.id) return '/';

        const partes = [
            producto.tipoRepuesto?.nombre,
            producto.marca?.nombre,
            producto.modelo?.nombre,
            producto.version?.nombre
        ].filter(Boolean).join(' ');

        const slug = String(partes)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-+|-+$)/g, '')
            .slice(0, 120);

        return slug ? `/producto/${producto.id}-${slug}` : `/producto/${producto.id}`;
    }

    /** Id de la publicacion a partir del slug (`123-turbo-...` -> 123). */
    idDesdeSlug = (slug: string) => {
        const match = /^(\d+)/.exec(slug || '');
        return match ? match[1] : undefined;
    }

}


const productoServiceTs = new ProductoServiceTs();

export default productoServiceTs;